import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getPendingInteractionsByServiceId } from '../api/pendingInteraction';
import { PendingInteractionKey } from '../configs/pendingInteraction';
import { PendingInteractionFormType } from '../@types/pendingInteraction.type';

export const useGetPendingInteractionsByServiceId = (serviceId: number): UseQueryResult<PendingInteractionFormType[]> => {
  return useQuery({
    queryKey: [PendingInteractionKey, serviceId],
    queryFn: () => serviceId && getPendingInteractionsByServiceId(serviceId)
  });
};